import {
  Box,
  Table,
  Paper,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  IconButton,
  CircularProgress,
  TableContainer,
  Button,
  Stack,
} from "@mui/material";
import Iconify from "../iconify";

export default function VersusSeasonTypesTable({
  rows,
  loading,
  onMenuOpen,
  onAddNew,
}) {
  return (
    <>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="flex-end"
        mb={2}
      >
        <Button
          variant="contained"
          startIcon={<Iconify icon="eva:plus-fill" />}
          onClick={onAddNew}
        >
          New Season Type
        </Button>
      </Stack>
      {loading ? (
        <Box
          sx={{ display: "flex", justifyContent: "center" }}
          style={{ padding: 20 }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="versus season types table">
            <TableHead>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Title</TableCell>
                <TableCell>Teams</TableCell>
                <TableCell>Entry Fee</TableCell>
                <TableCell>Duration (Days)</TableCell>
                <TableCell>Ongoing</TableCell>
                <TableCell>Finished</TableCell>
                <TableCell>1st place</TableCell>
                <TableCell>MVPs</TableCell>
                <TableCell>Enabled</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows?.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell component="th" scope="row">
                    {row.versusSeasonTypeId}
                  </TableCell>
                  <TableCell>{row.title}</TableCell>
                  <TableCell>{row.size}</TableCell>
                  <TableCell>{row.entryFee}</TableCell>
                  <TableCell>
                    {Math.round(row.durationSeconds / 86400)}
                  </TableCell>
                  <TableCell>{row.ongoingCount}</TableCell>
                  <TableCell>{row.completedCount}</TableCell>
                  <TableCell>{row.winners}</TableCell>
                  <TableCell>{row.mvpWinners}</TableCell>
                  <TableCell component="th" scope="row">
                    {row.isEnabled ? (
                      <Iconify
                        icon={"eva:checkmark-circle-2-outline"}
                        sx={{ color: "green" }}
                      />
                    ) : (
                      <Iconify
                        icon={"eva:close-circle-outline"}
                        sx={{ color: "red" }}
                      />
                    )}
                  </TableCell>
                  <TableCell align="right">
                    <IconButton
                      size="large"
                      color="inherit"
                      onClick={(e) => onMenuOpen(e, row.versusSeasonTypeId)}
                    >
                      <Iconify icon={"eva:more-vertical-fill"} />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </>
  );
}
